<template>
  <div class="my-10">
    <recorder @mediaReady="onMediaReady" @cancel="showRecorder = false" v-if="showRecorder"></recorder>

    <div class="bg-white p-10 shadow-md">
      <div class="flex justify-center px-4 items-center">
        <h1 class="text-3xl font-bold text-center">{{ __("New job") }}</h1>
      </div>

      <form @submit.prevent="submit">
        <div class="mt-10 mx-auto max-w-sm w-full">
          <div class="flex-1 w-full mb-4">
            <text-input v-model="form.registration_number" :data-error="error('registration_number')" class="w-full" :label="__('Registration number')" placeholder="IS36CDR" required/>
            <div v-if="error('client_id', 'job')" class="mt-2 text-coral-400">{{ error('registration_number', 'job') }}</div>
          </div>

          <div class="flex-1 w-full mb-4">
            <text-input v-model="form.external_id" :data-error="error('external_id')" class="w-full" :label="__('Job number')" required/>
            <div v-if="error('external_id', 'job')" class="mt-2 text-coral-400">{{ error('external_id', 'job') }}</div>
            <div class="mt-1 text-sm text-gray-400">{{ __("Enter order number from Automaster/eCARS") }}</div>
          </div>

          <div class="flex-1 w-full mb-4">
            <div class="flex flex-col mb-4" v-if="!isSafari() && isMobile && form.media.file">
              <div class="text-center break-all mb-2">Fisier <span class="text-grey-dark text-sm">({{ filesize(form.media.file.size) }})</span></div>
              <button type="button" class="h-10 text-xl px-10 rounded-lg text-gray-500 border-2 border-gray-500 w-full" @click="removeMedia">{{ __("Cancel") }}</button>
            </div>

            <button type="button" class="h-10 text-xl px-10 rounded-lg text-coral-400 border-2 border-coral-400 w-full" @click="showRecorder = true" v-if="!isSafari() && isMobile && !form.media.file">
              {{ __("Add media") }}
            </button>

            <simple-media-input v-model="form.media.file" v-if="isSafari() || !isMobile"></simple-media-input>
            <div v-if="validationError('jobFile')" class="text-red-500 mt-2">{{ validationError('jobFile') }}</div>
          </div>

          <div class="flex flex-col sm:flex-row justify-between mt-10">
            <button @click="cancel()" type="button" class="mb-4 sm:mb-0 text-center text-xl px-4 min-w-40 py-2 rounded text-white bg-gray-600 hover:bg-gray-500">
              {{ __("Cancel") }}
            </button>

            <loading-button type="submit" :loading="submittingForm" class="justify-center text-xl px-4 min-w-40 py-2 rounded text-white bg-coral-400 hover:bg-coral-300">
              {{ __("Save") }}
            </loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import Icon from '@/Shared/Icon';
  import TextInput from '@/Shared/TextInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import SimpleMediaInput from '@/Shared/SimpleMediaInput';
  import Recorder from "../../Shared/Recorder";

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("New job")
      }
    },
    props: {},
    components: {
      Layout,
      LoadingButton,
      TextInput,
      SimpleMediaInput,
      Icon,
      Recorder
    },
    data() {
      return {
        showRecorder: false,
        submittingForm: false,
        formData: new FormData(),
        form: {
          media: {
            file: null,
            name: null
          },
          external_id: '',
          registration_number: '',
        }
      }
    },
    methods: {
      removeMedia() {
        this.form.media.file = null;
        this.form.media.name = null;
      },
      onMediaReady(file, name) {
        this.form.media.file = file;
        this.form.media.name = name;
        this.showRecorder = false;
      },
      cancel() {
        return window.history.back();
      },
      submit() {
        this.submittingForm = true;

        if (this.form.media.file) {
          if (this.form.media.name) {
            this.formData.append('jobFile', this.form.media.file, this.form.media.name);
          } else {
            this.formData.append('jobFile', this.form.media.file);
          }
        }

        this.formData.append('registration_number', this.form.registration_number);
        this.formData.append('external_id', this.form.external_id);
        this.$inertia.post(this.route('quickJobs.store'), this.formData);
      },
      filesize(size) {
        let i = Math.floor(Math.log(size) / Math.log(1024));
        return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
      }
    },
    computed: {
      isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      },
    }
  }
</script>
